var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosNotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_46440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53128 5.96098C7.57579 6.81948 7.96784 6.75431 9.93086 6.62115L28.4339 5.49773C28.826 5.49773 28.4997 5.10107 28.3695 5.0359L25.2948 2.78765C24.7067 2.32582 23.9212 1.79598 22.4175 1.92773L4.50245 3.2509C3.84998 3.31607 3.71836 3.64757 3.97879 3.91107L6.53128 5.96098ZM7.6416 10.3243V30.0216C7.6416 31.0799 8.16386 31.4766 9.34139 31.41L29.6759 30.22C30.8534 30.1548 30.985 29.4266 30.985 28.5667V9.00115C30.985 8.14265 30.6588 7.6794 29.9377 7.74457L8.68752 9.00115C7.90343 9.06773 7.6416 9.4644 7.6416 10.3229V10.3243ZM27.7156 11.3797C27.8459 11.9747 27.7156 12.5697 27.1276 12.6377L26.1475 12.8361V27.3767C25.2962 27.84 24.5121 28.1049 23.8582 28.1049C22.8109 28.1049 22.5491 27.7734 21.765 26.7831L15.3565 16.603V26.4516L17.3839 26.9163C17.3839 26.9163 17.3839 28.1063 15.7485 28.1063L11.2372 28.3698C11.107 28.1063 11.2372 27.4447 11.6951 27.313L12.8712 26.9829V13.9595L11.24 13.8263C11.1084 13.2313 11.436 12.3728 12.3503 12.3062L17.1893 11.9761L23.8596 22.2881V13.1647L22.1584 12.9678C22.0282 12.2396 22.5505 11.7112 23.2043 11.6461L27.7156 11.3797ZM2.99868 1.4659L21.6348 0.0775653C23.9226 -0.120768 24.5121 0.0109819 25.95 1.06923L31.8993 5.2994C32.8794 6.02615 33.2071 6.22448 33.2071 7.01782V30.22C33.2071 31.6735 32.6848 32.5348 30.8548 32.6651L9.21118 33.9883C7.83902 34.0549 7.18375 33.8566 6.46407 32.9301L2.08298 27.1784C1.29889 26.1201 0.972656 25.3282 0.972656 24.4017V3.7779C0.972656 2.58932 1.49631 1.59623 2.99868 1.4659Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_46440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6038,
    height: 34,
    fill: "white",
    transform: "translate(0.287109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosNotion);
export default __webpack_public_path__ + "static/media/logos_notion.88bc4c04f2633c89d7b28267ef0b1e57.svg";
export { ForwardRef as ReactComponent };